import { parseURL } from "ufo";

export function prepareUrlInContent(content: string): string {
  const $img = useImage();
  const { uploadsUrl } = useStrapiExtend();

  return content.replace(
    /<img[^>]*src="([^"]+)"[^>]*>/gm,
    (value, url: string) => {
      const ipxSrc = $img.getSizes(uploadsUrl(parseURL(url).pathname), {
        sizes: "xs:100vw md:100vw lg:1450px",
      });

      if (!ipxSrc) {
        return value;
      }

      return value
        .replace(url, ipxSrc.src || "")
        .replace(
          ">",
          ` sizes="${ipxSrc.sizes}" srcset="${ipxSrc.srcset}" loading="lazy">`,
        );
    },
  );
}
